import React from 'react'
import { Table } from '@medeo/components'
import { getDocumentsFromPatientId } from '../ducks'
import { connect } from 'react-redux'
import moment from 'moment'
const ReviewsHistoryTable = ({ documents }) => (
  <Table
    headers={[['mesure', 'valeur', 'date']]}
    rows={documents}
    renderRow={document => [
      <td key="value">
        <a href={document.content[0].attachment.url}>
          {moment(document.created).calendar()}
        </a>
      </td>
    ]}
  />
)

const mapStateToProps = (state, ownProps) => ({
  documents: getDocumentsFromPatientId(state, ownProps.patient),
  patient: ownProps.patient
})

export default connect(mapStateToProps)(ReviewsHistoryTable)



// WEBPACK FOOTER //
// ./src/Documents/containers/ReviewsHistoryTable.js